import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { initializeAuth, browserLocalPersistence } from 'firebase/auth';

// Replace with your Firebase project config
const firebaseConfig = {
  apiKey: "AIzaSyAp-lthduwgBxS3zgWo8y1WHORRl9Rov_E",
  authDomain: "besties-app-8d0b1.firebaseapp.com",
  projectId: "besties-app-8d0b1",
  storageBucket: "besties-app-8d0b1.firebasestorage.app",
  messagingSenderId: "1030669020596",
  appId: "1:1030669020596:web:69b86643861367597b96e1",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = initializeAuth(app, {
  persistence: browserLocalPersistence
});
const db = getFirestore(app);

export { auth, db };